import { render, staticRenderFns } from "./SntProductSetTable.vue?vue&type=template&id=0367abac&scoped=true&"
import script from "./SntProductSetTable.vue?vue&type=script&lang=js&"
export * from "./SntProductSetTable.vue?vue&type=script&lang=js&"
import style0 from "./SntProductSetTable.vue?vue&type=style&index=0&id=0367abac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0367abac",
  null
  
)

export default component.exports